function init(selector = '.select-point-redemption-method') {
  const dropdowns = document.querySelectorAll(selector);

  for (const dropdown of dropdowns) {
    const dropdownTrigger = dropdown.querySelector(
      '.select-point-redemption-method__trigger',
    );
    const dropdownContent = dropdown.querySelector(
      '.select-point-redemption-method__dropdown',
    );
    const dropdownOptions = dropdown.querySelectorAll(
      '.select-point-redemption-method__option',
    );
    const message = dropdown.querySelector(
      '.select-point-redemption-method_message',
    );

    // Check if event listener already exists
    if (!dropdownTrigger.hasAttribute('data-listener-added')) {
      dropdownTrigger.addEventListener('click', function() {
        dropdownTrigger.classList.toggle('active');
        dropdownContent.classList.toggle('active');
      });
      dropdownTrigger.setAttribute('data-listener-added', 'true');
    }

    dropdownOptions.forEach((option) => {
      // Check if event listener already exists
      if (!option.hasAttribute('data-listener-added')) {
        option.addEventListener('click', function() {
          // Check if option is disabled
          if (option.dataset.disabled === '1') {
            // Just close the dropdown if disabled
            dropdownTrigger.classList.remove('active');
            dropdownContent.classList.remove('active');
            return;
          }

          const selectedValue = option.dataset.value;
          dropdownTrigger.querySelector('p').textContent = option.dataset.text;
          dropdownTrigger.querySelector('p').classList.add('selected');
          dropdownOptions.forEach((option) => {
            option.classList.remove('selected');
          });
          option.classList.add('selected');
          dropdownTrigger.classList.remove('active');
          dropdownContent.classList.remove('active');

          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                _roadmap_loyalty_reward_id: selectedValue,
              },
              sections: ['sections--18888581415085__cart-drawer'],
            }),
            mode: 'cors',
            credentials: 'include',
          })
          .then(response => response.json())
          .then(cartContent => {
            // Dispatch cart:change event to trigger cart updates throughout the theme
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'point-redemption:update',
                cart: cartContent
              }
            }));
          })
          .catch(console.error);
        });
        option.setAttribute('data-listener-added', 'true');
      }
    });
  }
}
window.initSelectPointRedemptionMethod = init;